// extracted by mini-css-extract-plugin
module.exports = {"list":"tags_list__IHHMe","item":"tags_item__c2_Ry","upperCase":"tags_upperCase__xNimH","tags-featured":"tags_tags-featured__WlCWi"};